import { render, staticRenderFns } from "./CanvasStage.vue?vue&type=template&id=4a0b5242&scoped=true&"
import script from "./CanvasStage.vue?vue&type=script&lang=js&"
export * from "./CanvasStage.vue?vue&type=script&lang=js&"
import style0 from "./CanvasStage.vue?vue&type=style&index=0&id=4a0b5242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0b5242",
  null
  
)

export default component.exports